'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var locale = {
  placeholder: '날짜 선택'
};

exports['default'] = locale;